import * as tokens from '../../../../../tokens/color.light.generated.js';
export const globalColorLight = {
    color: {
        action: {
            toggleButton: {
                indicator: {
                    default: tokens.CMP_COLOR_ACTION_TOGGLE_BUTTON_INDICATOR_DEFAULT_LIGHT
                }
            }
        },
        typography: {
            copy: {
                default: tokens.GLOBAL_COLOR_TYPOGRAPHY_COPY_DEFAULT_LIGHT
            },
            headline: {
                default: tokens.GLOBAL_COLOR_TYPOGRAPHY_HEADLINE_DEFAULT_LIGHT
            }
        },
        elevation: {
            level3: tokens.GLOBAL_COLOR_ELEVATION_LEVEL3_LIGHT
        }
    }
};
//# sourceMappingURL=color.light.js.map